import UpdateAppSystemWebApiRequestModelBase from '../_generated/modelBases/update-app-system-web-api-request-model-base';

export default class UpdateAppSystemWebApiRequestModel extends UpdateAppSystemWebApiRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
